const CollapsiblePanel = ({
  children,
  title,
  className = "",
}) => {

  return (
    <div className={`space-y-2 ${className}`}>
      <div className="flex flex-wrap items-center bg-[var(--theme-primary)] rounded gap-2 px-3 py-1">
        <div className="bg-transparent text-[var(--theme-on-primary)] font-semibold rounded text-sm">
            {title}
        </div>
      </div>
      {children}
    </div>
  );
};

export default CollapsiblePanel;
